// 全局配置文件
export default {

  lang :"ch",//使用语言种类，国际化处理（中文）
  // lang :"en",//使用语言种类，国际化处理（英文）
  imgPath:"https://i.loli.net/",//图片访问路径url
  equipmentType:"PC",//访问设备类型(pc / mobile /iPad)

};
